var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('h1',[_vm._v("Dashboard")])])],1),_c('v-row',[_c('v-col',[_c('v-switch',{attrs:{"inset":"","label":"Include Contingent Workers"},model:{value:(_vm.includeContingentWorkers),callback:function ($$v) {_vm.includeContingentWorkers=$$v},expression:"includeContingentWorkers"}})],1)],1),_c('v-row',[_c('v-col',[_c('v-autocomplete',{attrs:{"items":_vm.departmentFilterOptions,"label":"Departments","solo":"","rounded":"","multiple":"","chips":""},model:{value:(_vm.departmentFilter),callback:function ($$v) {_vm.departmentFilter=$$v},expression:"departmentFilter"}})],1),_c('v-col',[_c('v-autocomplete',{attrs:{"items":_vm.locationFilterOptions,"label":"Locations","solo":"","rounded":"","multiple":"","chips":""},model:{value:(_vm.locationFilter),callback:function ($$v) {_vm.locationFilter=$$v},expression:"locationFilter"}})],1)],1),_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('PieCard',{attrs:{"title":"Manager Training","pieData":_vm.managerTrainingPieChartData,"panels":[
          {
            employees: _vm.needsManagerTraining,
            header: 'Needs Manager Training'
          },
          {
            employees: _vm.attendedManagerTraining,
            header: 'Attended Manager Training'
          }
        ]}})],1),_c('v-col',{attrs:{"cols":"6"}},[_c('PieCard',{attrs:{"title":"Sexual Harassment Training","pieData":_vm.sexualHarassmentTrainingPieChartData,"panels":[
          {
            employees: _vm.sexualHarassmentTrainingOverdue,
            header: 'Needs Sexual Harassment Training'
          },
          {
            employees: _vm.sexualHarassmentTrainingCompliant,
            header: 'Attended Sexual Harassment Training'
          },
          {
            employees: _vm.sexualHarassmentTrainingOverdueNextMonth,
            header: 'Will Require Sexual Harassment Training Next Month'
          }
        ]}})],1),_c('v-col',{attrs:{"cols":"6"}},[_c('PieCard',{attrs:{"title":"Diversity Training","pieData":_vm.diversityTrainingPieChartData,"panels":[
          {
            employees: _vm.needsDiversityTraining,
            header: 'Needs Diversity Training'
          },
          {
            employees: _vm.attendedDiversityTraining,
            header: 'Attended Diversity Training'
          }
        ]}})],1),_c('v-col',{attrs:{"cols":"6"}},[_c('PieCard',{attrs:{"title":"COVID-19 Training","pieData":_vm.covid19TrainingPieChartData,"panels":[
          {
            employees: _vm.needsCovid19Training,
            header: 'Needs COVID-19 Training'
          },
          {
            employees: _vm.attendedCovid19Training,
            header: 'Attended COVID-19 Training'
          }
        ]}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }